"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Loading.scss");
function Loading(props) {
    var _a;
    var loadingText = (_a = props === null || props === void 0 ? void 0 : props.text) !== null && _a !== void 0 ? _a : "Loading";
    return (react_1.default.createElement("div", { className: "loadingBackground" },
        react_1.default.createElement("div", { className: "loadingWidget" },
            react_1.default.createElement("div", { className: "spinner-border text-light loadingSpinner", role: "status" }),
            react_1.default.createElement("span", { className: "loadingText", role: "alert" }, loadingText))));
}
exports.default = Loading;
